import { Flex, Image, Spinner } from "@chakra-ui/react";
import { useGlobalContext } from "@root/context/global-context";
import { SidebarIcon } from "@root/assets/icons/sidebaricon";
import { useOrganizationBranding } from "@root/context/organization-branding-context";

export function SidebarHeader({
  lg,
  isDarkTheme,
  isSidebarOpen: propIsSidebarOpen,
  setIsSidebarOpen: propSetIsSidebarOpen,
}: any) {
  const context = useGlobalContext();
  const { logoUrl, defaultLogoUrl, loading } = useOrganizationBranding();
  const isSidebarOpen =
    propIsSidebarOpen !== undefined ? propIsSidebarOpen : context.isSidebarOpen;
  const setIsSidebarOpen =
    propSetIsSidebarOpen !== undefined
      ? propSetIsSidebarOpen
      : context.setIsSidebarOpen;

  return (
    <Flex
      alignItems={"center"}
      justifyContent={"center"}
      minW={isSidebarOpen ? "205px" : undefined}
    >
      {isSidebarOpen ? (
        loading ? (
          <Spinner size="md" />
        ) : (
          <Image
            src={logoUrl || defaultLogoUrl}
            alt="Logo"
            maxH="38px"
            objectFit="contain"
          />
        )
      ) : (
        <SidebarIcon
          boxSize={6}
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
        />
      )}
    </Flex>
  );
}
